// Сервис для загрузки зависимостей карты meteoblue

const MAPBOX_JS_URL = 'https://static.meteoblue.com/cdn/mapbox-gl-js/v1.11.1/mapbox-gl.js';
const MAPBOX_JS_INTEGRITY = 'sha512-v5PfWsWi47/AZBVL7WMNqdbM1OMggp9Ce408yX/X9wg87Kjzb1xqpO2Ul0Oue8Vl9kKOcwPM2MWWkTbUjRxZOg==';
const MAPBOX_CSS_URL = 'https://static.meteoblue.com/cdn/mapbox-gl-js/v1.11.1/mapbox-gl.css';
const MAPBOX_CSS_INTEGRITY = 'sha512-xY1TAM00L9X8Su9zNuJ8nBZsGQ8IklX703iq4gWnsw6xCg+McrHXEwbBkNaWFHSqmf6e7BpxD6aJQLKAcsGSdA==';
const METEOBLUE_PLUGIN_URL = 'https://static.meteoblue.com/lib/maps-plugin/v0.x/maps-plugin.js';

class MeteoblueLoader {
  constructor() {
    this.loadPromise = null;
  }

  async load() {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = (async () => {
      await this.loadCss(MAPBOX_CSS_URL, MAPBOX_CSS_INTEGRITY);
      await this.loadScript(MAPBOX_JS_URL, MAPBOX_JS_INTEGRITY);
      await this.loadScript(METEOBLUE_PLUGIN_URL);

      if (!window.mapboxgl) {
        throw new Error('Mapbox GL JS failed to load');
      }

      if (!window.meteoblueMapsPlugin) {
        throw new Error('meteoblue Maps Plugin failed to load');
      }

      return {
        mapboxgl: window.mapboxgl,
        meteoblueMapsPlugin: window.meteoblueMapsPlugin
      };
    })().catch(error => {
      this.loadPromise = null;
      throw error;
    });

    return this.loadPromise;
  }

  loadScript(src, integrity = null, crossOrigin = 'anonymous') {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      if (integrity) {
        script.integrity = integrity;
      }
      if (crossOrigin) {
        script.crossOrigin = crossOrigin;
      }
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  loadCss(href, integrity = null, crossOrigin = 'anonymous') {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`link[href="${href}"]`)) {
        resolve();
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      if (integrity) {
        link.integrity = integrity;
      }
      if (crossOrigin) {
        link.crossOrigin = crossOrigin;
      }
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }
}

export default new MeteoblueLoader();
